import { RestrictionTier } from "@redotech/crdb-enums/xborder-outbound/restriction-tier";
import * as z from "zod";

export const restrictionTier = z.enum(RestrictionTier);
